import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import * as appVersion from '../app-version.json';

/**
 * The build's version, which the build stamps into app-version.json. CloudFront tells browsers to
 * keep assets for two days, and a translation file keeps its name from one release to the next, so
 * without it a browser would show a new release's keys untranslated until its copy expired.
 */
const TRANSLATIONS_VERSION = encodeURIComponent(appVersion.appVersion);

@Injectable({ providedIn: 'root' })
export class PortalTranslocoLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json?v=${TRANSLATIONS_VERSION}`);
  }
}
